import React, { useRef, useState } from "react";
import { Dropdown } from "react-day-picker";
import SvgIcon from "../SvgIcon";
import RadioVerticalGroup from "./radio-vertical-group";
import useClickOutside from "../../hooks/useClickOutside";

const RadioGroupDropdown = ({
  placeholder,
  required = true,
  name,
  currentValue,
  radios = [],
  onChange,
}) => {
  const [opened, setOpened] = useState(false);
  const handleClick = (e) => {
    e.preventDefault();
    setOpened(!opened);
  };
  const dropdownRef = useRef(null);
  useClickOutside(
    dropdownRef,
    () => {
      setOpened(false);
    },
    opened
  );
  return (
    <details ref={dropdownRef} role="list" open>
      <summary onClick={handleClick} aria-haspopup="listbox">
        {radios.find((widgetType) => widgetType.value === currentValue)
          ?.label || placeholder}
        <SvgIcon
          src={opened ? "/img/svg/angle-up.svg" : "/img/svg/angle-down.svg"}
        />
      </summary>
      <ul
        role="listbox"
        className={opened ? "opened radio-group" : "radio-group"}
      >
        {radios.map((radio, i) => {
          const value = radio.value ? radio.value : radio;
          const label = radio.label ? radio.label : radio;
          return (
            <li
              key={i}
              onClick={() => {
                onChange({ target: { name, value } });
                setOpened(false);
              }}
            >
              <div>
                <input
                  name={name}
                  id={value}
                  type="radio"
                  value={value}
                  className="radio"
                  // onChange={(e) => {
                  //   onChange(e);
                  //   setOpened(false);
                  // }}
                  checked={currentValue === value}
                />
                <label className="radio-label" htmlFor={value}>
                  {label}
                </label>
              </div>
            </li>
          );
        })}
      </ul>
    </details>
  );
};

export default RadioGroupDropdown;
